import type { Reducer } from 'redux';

import type {
  TopicsAllLoadFulfilledAction,
  TopicsAllLoadMoreFulfilledAction,
} from '../../domains/engageTopicsAll/actions.types';
import type { RemoveTopicFulfilledProps } from '../../domains/topics/removeTopicActions';
import type { RemoveTopicFulfilledAction } from '../../domains/topics/removeTopicActions.types';
import type { TopicsBulkDeleteFulfilledAction } from '../../domains/topicsBulkDelete/actions.types';
import type { Topic } from '../topics/types';

import type { TopicsAllEdge } from './types';

const loadTopicsAll = (state: TopicsAllEdge, topicsAllEdge: TopicsAllEdge) => ({
  ...state,
  ...topicsAllEdge,
});

const loadMoreTopicsAll = (state: TopicsAllEdge, topicsAllEdge: TopicsAllEdge) => {
  const currentTopicIds = state.topicIds;

  const topicIds = [...currentTopicIds, ...topicsAllEdge.topicIds];

  return { ...state, ...topicsAllEdge, topicIds };
};

const removeTopic = (state: TopicsAllEdge, payload: RemoveTopicFulfilledProps) => {
  const topicIds = state.topicIds.filter((topicId) => topicId !== payload.topicId);
  const topicsCount = state.topicsCount - 1;

  return { ...state, topicIds, topicsCount };
};

const removeTopics = (state: TopicsAllEdge, topicIdsArray: Topic['id'][]) => {
  const topicIds = state.topicIds.filter((topicId) => !topicIdsArray.includes(topicId));
  const topicsCount = state.topicsCount - topicIdsArray.length;

  return { ...state, topicIds, topicsCount };
};

export const initialState: TopicsAllEdge = { cursor: null, hasNextPage: false, topicIds: [], topicsCount: 0 };

export type TopicsAllAction =
  | TopicsAllLoadFulfilledAction
  | TopicsAllLoadMoreFulfilledAction
  | RemoveTopicFulfilledAction
  | TopicsBulkDeleteFulfilledAction;

const reducer: Reducer<TopicsAllEdge, TopicsAllAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPICS_ALL.LOAD_FULFILLED':
      return loadTopicsAll(state, action.payload.entities.topicsAllEdge);
    case 'TOPICS_ALL.LOAD_MORE_FULFILLED':
      return loadMoreTopicsAll(state, action.payload.entities.topicsAllEdge);
    case 'TOPIC.REMOVE_FULFILLED':
      return removeTopic(state, action.payload);
    case 'TOPICS.BULK_DELETE_FULFILLED':
      return removeTopics(state, action.payload.topicIds);
    default:
      return state;
  }
};

export default reducer;
